import BigNumber from 'bignumber.js';

import { Order } from '#/api/orders';
import { MarketSummary } from '#/api/markets-summary';
import { Market } from '#/api/markets';

import * as MarketFn from '#/features/market/functions';

export function getPriceByOrderType(
  orderType: Order['type'],
  marketSummary: MarketSummary,
  limitPrice: BigNumber | null,
): BigNumber | null {
  if (orderType === 'LIMIT') return limitPrice;

  if (marketSummary.oracle_price == null) return null;
  return marketSummary.oracle_price;
}

export function convertAmountToQuoteAsset(
  // WIP: investigate refactor to do not call function with potential null `asset`
  asset: string | null,
  amount: BigNumber,
  price: BigNumber,
  market: Market,
): BigNumber {
  if (asset == null) {
    return amount;
  }

  if (asset === market.base_currency) {
    return amount.multipliedBy(price);
  }

  if (asset === market.quote_currency) {
    return amount;
  }

  throw new Error(
    `${asset} does not match market ${market.base_currency}/${market.quote_currency} asset`,
  );
}

export function convertAmountToBaseAsset(
  // WIP: investigate refactor to do not call function with potential null `asset`
  asset: string | null,
  amount: BigNumber,
  price: BigNumber,
  activeMarket: Market,
): BigNumber | null {
  if (asset == null) {
    return amount;
  }

  if (asset === activeMarket.base_currency) {
    return amount;
  }

  if (asset === activeMarket.quote_currency) {
    const amountBaseAsset = amount.dividedBy(price);
    const value = amountBaseAsset.isFinite()
      ? amountBaseAsset.decimalPlaces(
          MarketFn.baseCurrencyDecimalPlaces(activeMarket),
        )
      : null;

    return value;
  }

  throw new Error(
    `${asset} does not match market ${activeMarket.base_currency}/${activeMarket.quote_currency} asset`,
  );
}
